import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function HowItWorksClosing() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-white" data-id="element-782">
      <div className="max-w-4xl mx-auto text-center" data-id="element-783">
        <h2 className="text-4xl md:text-5xl font-bold font-['Syne'] text-black mb-8 leading-tight" data-id="element-784">
          AI shouldn't guess at what matters to your business.
        </h2>

        <p className="text-xl text-gray-600 font-light leading-relaxed mb-6" data-id="element-785">
          Synthia makes your institutional intelligence machine-readable—so
          every AI interaction reflects how your company actually works. Same
          model. Same employee. Completely different output.
        </p>

        <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0066FF]" data-id="element-786">
          BOOK A DEMO
          <ArrowRight className="w-5 h-5" data-id="element-787" />
        </Link>
      </div>
    </section>;
}